module.exports = "// Copyright (c) Microsoft. All rights reserved.\r\n// Licensed under the MIT license. See LICENSE file in the project root for full license information.\r\n\r\n#ifndef IOTHUB_CLIENT_SAMPLE_MQTT_H\r\n#define IOTHUB_CLIENT_SAMPLE_MQTT_H\r\n\r\n#include \"iothub_client_ll.h\"\r\n\r\nvoid iothubInit(void);\r\nvoid iothubSendMessage(const unsigned char *, bool);\r\nvoid iothubLoop(void);\r\nvoid iothubClose(void);\r\n\r\nextern int messageCount;\r\n#endif /* IOTHUB_CLIENT_SAMPLE_MQTT_H */"


//////////////////
// WEBPACK FOOTER
// ./src/data/GetStarted/iothub_client_sample_mqtt.h
// module id = 402
// module chunks = 0